import { DialogComponent } from './../../../components/dialog/dialog.component';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { FirestoreService } from 'src/app/services/service.index';
import {SelectionModel} from '@angular/cdk/collections';
import Swal from 'sweetalert2';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
@Component({
  selector: 'app-orders',
  templateUrl: './orders.component.html',
  styleUrls: ['./orders.component.css']
})
export class OrdersComponent implements OnInit {


  forma: FormGroup;
  //'id',
  //'location'
  //'time', 'total',
  //'distance',
  displayedColumns: string[] = [ 'company', 'firstname', 'lastname', 'address',  'datedelivery', 'phone',   'status', 'actions'];

  dataSource = new MatTableDataSource();

  user:any;

  dateto:any;
  datefrom:any;

  selection = new SelectionModel<any>(true, []);

  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: true}) sort: MatSort;

  constructor(private afs: FirestoreService, public dialog: MatDialog) { }

  ngOnInit(): void {

    this.forma = new FormGroup({
        dateto: new FormControl( null, Validators.required),
        datefrom: new FormControl( null, Validators.required),

    });

    this.user = this.afs.usersShow;

    this.searchAllOrders();




  }

  ngAfterViewInit(){
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  sortData(sort: Sort) {
    //const data = ELEMENT_DATA.slice();
    if (!sort.active || sort.direction === '') {
      //this.sortedData = data;
      return;
    }
  }

 applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  deleteOrder(order:any){

     Swal.fire({
       title: 'Are you sure?',
       text: "You won't be able to revert this!",
       icon: 'warning',
       showCancelButton: true,
       confirmButtonColor: '#3085d6',
       cancelButtonColor: '#d33',
       confirmButtonText: 'Yes, delete it!',
     }).then((result) => {
       if (result.value) {
         if (order.orderId != undefined) {
           this.afs
             .deleteRequestOrder(order.orderId)
             .then((r: any) => {
               console.log(r);
             })
             .catch((error) => {
               console.log(error);
             });
         }

         this.afs
           .deleteOrder(this.user.companyId, order.id)
           .then((resp: any) => {


              Swal.fire('Oops...', 'Order has been deleted!!', 'error');
           })
           .catch((error) => {
             console.log(error);
           });
       }
     });


  }

  statusOrder(status){

    if(status == 0)
    {
      return "Pending";
    }
    else if(status == 1)
    {
      return "Assigned";
    }
    else if(status == 2)
    {
      return "Delivered";
    }
    else if(status == 3)
    {
      return "Reject";
    }
  }


searchByDate(){

  let datefrom = new Date(this.forma.value.datefrom).getTime();
  let dateto = new Date(this.forma.value.dateto).getTime();

  console.log(dateto);
  console.log(datefrom);


  this.afs.getAllOrdersByDate(this.user.companyId, dateto, datefrom).subscribe(orders => {


    this.dataSource.data = orders;


  });

}

searchAllOrders(){

  this.forma.controls['dateto'].setValue('');
  this.forma.controls['datefrom'].setValue('');


  this.afs.getAllOrders(this.user.companyId).subscribe(orders => {

    this.dataSource.data = orders;

  });
}

getColorStatus(status){

    if(status == 0){
        return '#e74c3c'
    }else if(status ==1){
       return '#2980b9'
    }else if(status == 2){
       return '#2ecc71'
    }else if(status == 3){
        return '#e74c3c'
     }

}





}
